import { Menu, } from '@fluentui/react-components';
import React, { useCallback } from 'react';
import { ActionContextMenuPopover } from './ActionContextMenuPopover';
import { ActionMenuTrigger } from './ActionMenuTrigger';
export var ActionCommandMenuItem = function (_a) {
    var _b;
    var documentAction = _a.documentAction, onCommandMenuToggled = _a.onCommandMenuToggled;
    var icon = (_b = documentAction.contentActionOptions) === null || _b === void 0 ? void 0 : _b.icon;
    var subMenus = documentAction.subMenus || [];
    var isDisabled = documentAction.disabled;
    var isMenuAction = subMenus.length === 0;
    var maybeExecuteMenuAction = function () {
        if (isMenuAction && documentAction.executeAction && !isDisabled) {
            documentAction.executeAction();
        }
    };
    // Allow parent to handle closing the menu (return null)
    var onOpenChange = useCallback(function (_e, data) {
        if (onCommandMenuToggled) {
            onCommandMenuToggled(data.open);
        }
    }, [onCommandMenuToggled]);
    return (React.createElement(Menu, { onOpenChange: onOpenChange },
        React.createElement(ActionMenuTrigger, { ariaLabel: documentAction.ariaLabel, icon: icon, tooltip: isDisabled
                ? documentAction.tooltipString
                : documentAction.title, onClickCallback: maybeExecuteMenuAction, disabled: isDisabled }),
        React.createElement(ActionContextMenuPopover, { items: subMenus, hidden: isMenuAction })));
};
//# sourceMappingURL=ActionCommandMenuItem.js.map